<template>
  <generic-modal
    :title="$t('order details')"
    ref="generic_modal"
    :is_wide="true"
  >
    <div class="title is-4 is-pulled-right">
      {{ format_date(meta.created_date) }}
    </div>
    <div v-if="meta.customer" class="mb-5">
      <div class="title is-4">{{ meta.customer.name }}</div>
      <div class="subtitle is-6">
        <span class="icon">
          <i class="fa fa-at"></i>
        </span>
        {{ meta.customer.email }}
        <span class="icon">
          <i class="fa fa-phone"></i>
        </span>
        {{ meta.customer.phone }}
      </div>
    </div>

    <div class="title is-5 has-text-primary">
      {{ translate_status(meta.status_code) }}
    </div>
    <div class="subtitle is-5 mb-5" v-if="meta.settings && meta.settings">
      <span class="icon has-text-primary">
        <i class="fa fa-clock-o"></i>
      </span>
      {{ format_date(meta.settings.reception_date) }}
      <span class="icon has-text-warning">
        <i class="fa fa-clock-o"></i>
      </span>
      {{ format_date(meta.settings.delivery_date) }}
    </div>

    <!-- <div class="title is-5 mb-1">{{ $t("embroidery list") }}</div> -->
    <div class="content">
      <ul>
        <li v-for="item in meta.embroidery_list">
          <span class="title is-5"
            >{{ item.quantity }} x
            <span class="has-text-primary">{{
              item.embroidery ? item.embroidery.name : ""
            }}</span
            ><span class="has-text-warning">
              ({{
                format_currency(
                  Number(item.quantity) * Number(item.sale_price)
                )
              }})
            </span></span
          >

          <div class="columns">
            <div class="column">
              <div
                v-if="
                  item.embroidery &&
                  item.embroidery.settings &&
                  item.embroidery.settings.images
                "
                class="grid is-col-min-10"
              >
                <div
                  class="cell"
                  v-for="file in item.embroidery.settings.images"
                >
                  <div class="card">
                    <div class="card-content">
                      <div class="media">
                        <div class="media-left">
                          <figure class="image is-48x48">
                            <v-lazy-image
                              class="image is-128x128"
                              :src="`${api_host}/drive/static/${file.final_name}`"
                            />
                          </figure>
                        </div>
                        <div class="media-content">
                          <p class="title is-4">{{ file.original_name }}</p>
                          <p class="subtitle is-6">{{ file.meta.mimetype }}</p>
                        </div>
                      </div>
                    </div>
                    <footer class="card-footer">
                      <a
                        href="#"
                        class="card-footer-item"
                        @click="download_file(file)"
                        >{{ $t("download") }}</a
                      >
                    </footer>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div
                v-if="
                  item.embroidery &&
                  item.embroidery.settings &&
                  item.embroidery.settings.files
                "
                class="grid is-col-min-10"
              >
                <div
                  class="cell"
                  v-for="file in item.embroidery.settings.files"
                >
                  <div class="card">
                    <div class="card-content">
                      <div class="media">
                        <div class="media-left">
                          <figure class="image is-48x48">
                            <v-lazy-image
                              class="image is-64x64"
                              :src="calculate_icon(file)"
                            />
                          </figure>
                        </div>
                        <div class="media-content">
                          <p class="title is-6">{{ file.original_name }}</p>
                          <p class="subtitle is-6">{{ file.meta.mimetype }}</p>
                        </div>
                      </div>
                    </div>
                    <footer class="card-footer">
                      <a
                        href="#"
                        class="card-footer-item"
                        @click="download_file(file)"
                        >{{ $t("download") }}</a
                      >
                    </footer>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <pre v-if="item.embroidery">{{ item.embroidery.settings }}</pre> -->
        </li>
      </ul>
    </div>

    <div class="title is-4 is-pulled-right has-text-primary mt-4">
      {{ format_currency(meta.total) }}
    </div>

    <!-- <pre>{{ meta }}</pre> -->

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
  <create-customer-modal ref="create_customer_modal" />
</template>
<script>
import {
  put,
  get,
  post,
  generate_error_message_text,
  format_date,
  del,
  confirm_deletion_dialog,
  error_message,
  success_message,
  api_host,
  download,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import CreateCustomerModal from "../../../customer/frontend/customers_datatable/customer_modal/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "OrderDetailsModal",
  components: {
    GenericModal,
    GenericDropdown,
    CreateCustomerModal,
    VLazyImage,
  },
  props: {},
  data() {
    return {
      meta: {
        settings: {},
      },
      error: "",
      api_host,
    };
  },
  computed: {
    total() {
      let v = this;
      let total = 0;
      if (v.meta.embroidery_list) {
        total = v.meta.embroidery_list.reduce((acc, curr) => {
          let quantity = isNaN(curr.quantity) ? 0 : Number(curr.quantity);
          let sale_price = isNaN(curr.sale_price) ? 0 : Number(curr.sale_price);
          return acc + quantity * sale_price;
        }, 0);
      }
      return total;
    },
  },
  methods: {
    format_currency,
    format_date,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(order_uuid) {
      let v = this;
      v.set_initial_state();
      get("/embroidery-order", { uuid: order_uuid })
        .then((res) => {
          v.meta = res;
          v.meta.embroidery_list = res.embroidery_order_items;
          delete v.meta.embroidery_order_items;
        })
        .catch((err) => {
          v.error = generate_error_message_text(err);
        });

      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.provider_uuid = undefined;
      v.meta = {
        settings: {},
        embroidery_list: [
          {
            embroidery_id: "",
            sale_price: "",
            quantity: 1,
          },
        ],
      };
      v.error = "";
    },
    translate_status(status_code) {
      let v = this;
      switch (status_code) {
        case "N":
          return v.$t("new");
        case "D":
          return v.$t("discarded");
        case "L":
          return v.$t("delivered");
        case "F":
          return v.$t("finished");
        case "B":
          return v.$t("buying materials");
        case "P":
          return v.$t("in production");
        default:
          return status_code;
      }
    },
    calculate_icon(file) {
      // console.log(file);
      // let v = this;
      if (file.meta.mimetype == "application/pdf")
        // return "https://static.vecteezy.com/system/resources/previews/015/081/201/non_2x/pdf-file-format-3d-rendering-isometric-icon-png.png";
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-pdf-color-red-icon.png";
      else if (file.meta.mimetype == "image/jpeg")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-jpeg-color-red-icon.png";
      else if (file.meta.mimetype == "image/png")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-png-color-red-icon.png";
      else if (file.meta.mimetype == "application/json")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-json-color-red-icon.png";
      else if (file.meta.mimetype == "application/x-javascript")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-js-color-red-icon.png";
      else if (
        file.meta.mimetype ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      )
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-xlsx-color-green-icon.png";
      else if (file.meta.mimetype == "text/x-python")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-py-color-green-icon.png";
      else if (file.meta.mimetype == "image/webp")
        return "https://uxwing.com/wp-content/themes/uxwing/download/file-and-folder-type/file-webp-color-green-icon.png";
      else
        return "https://cdn.icon-icons.com/icons2/2753/PNG/512/ext_file_generic_filetype_icon_176256.png";
    },
    download_file(file) {
      // console.log("download file", file);
      let v = this;
      download(
        `/embroidery-order/file/download?id=${file.file_id}`,
        file.original_name
      )
        .then(() => {
          success_message(v.$t("download complete"));
        })
        .catch((error) => {
          error_message(error);
        });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
